'use client';

import React, { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { Page } from '@weareconceptstudio/core';

//* Components
import Footer from '../Footer';
import ScrollWrapper from '../ScrollWrapper';
import { useFulfillmentCartGuard } from '@/hooks/useFulfillmentCartGuard';
import { useFulfillmentRedirectRestore } from '@/hooks/useFulfillmentRedirectRestore';
import { usePageLoadingReset } from '@/hooks/usePageLoadingReset';

const HighOrderComponent = ({ children, lang }) => {
	const pathname = usePathname();
	useFulfillmentCartGuard({ enableRouteGuard: true });
	useFulfillmentRedirectRestore();
	usePageLoadingReset();

	const cleanedPathname = useMemo(() => {
		if (!lang) {
			return pathname;
		}

		return pathname.replace(new RegExp(`^/${lang}(/|$)`), '/') || '/';
	}, [pathname, lang]);

	const isPackage = useMemo(() => {
		const normalizedPath = cleanedPathname.endsWith('/') ? cleanedPathname : `${cleanedPathname}/`;

		const exactPackageRoutes = [
			'/sign-in/',
			'/sign-up/',
			'/forgot-password/',
			'/reset-password/',
			'/verify-phone/',
			'/thank-you-message/',
			'/payment-failed/',
			'/cart/',
			'/checkout/',
			'/order-review/',
		];

		const packageRoutePrefixes = ['/account/'];

		return (
			exactPackageRoutes.includes(normalizedPath) ||
			packageRoutePrefixes.some((prefix) => normalizedPath.startsWith(prefix))
		);
	}, [cleanedPathname]);

	return (
		<ScrollWrapper>
			{isPackage ? children : <Page>{children}</Page>}
			<Footer />
		</ScrollWrapper>
	);
};

export default HighOrderComponent;
